export const PAGE_BLOCK_SPACING = {
  base: 64,
  md: 96,
};

export const MIGRATION_PATHS: string[] = [
  "/migration-ebp-hubbix/",
  "/migration-hubbix/",
  "/migration-hubbix",
  "/migration-boby/",
  "/migration-boby",
  "/migration-cegid-business/",
  "/migration-ebp-batiment-hubbix/",
  "/migration-ebp-gestion-commerciale-hubbix/",
];
